import { useQuery } from '@tanstack/react-query'
import { adminApi } from '@/api/admin'
import { portalApi } from '@/api/portal'
import { trainerApi } from '@/api/trainer'
import { attendeeApi } from '@/api/attendee'
import { datesFor, type Dates } from '@/lib/dates'

export type { Dates }

const STALE = 5 * 60 * 1000

/** Admin app: the tenant's region and time zone from the shared company-profile query. */
export function useAdminDates(): Dates {
  const { data } = useQuery({
    queryKey: ['company-profile'],
    queryFn: () => adminApi.getCompanyProfile().then(r => r.data),
    staleTime: STALE,
  })
  return datesFor(data?.region, data?.timeZoneId)
}

/** Client portal: from the branding query PortalLayout already loads. */
export function usePortalDates(): Dates {
  const { data } = useQuery({
    queryKey: ['portal-branding'],
    queryFn: () => portalApi.getBranding().then(r => r.data),
    staleTime: STALE,
  })
  return datesFor(data?.region, data?.timeZoneId)
}

/** Trainer portal: from the trainer's own profile. */
export function useTrainerDates(): Dates {
  const { data } = useQuery({
    queryKey: ['trainer-profile-dates'],
    queryFn: () => trainerApi.getMyProfile().then(r => r.data),
    staleTime: STALE,
  })
  return datesFor(data?.region, data?.timeZoneId)
}

/** Attendee portal: from the attendee's profile. */
export function useAttendeeDates(): Dates {
  const { data } = useQuery({
    queryKey: ['attendee-profile-dates'],
    queryFn: () => attendeeApi.getMe().then(r => r.data),
    staleTime: STALE,
  })
  return datesFor(data?.region, data?.timeZoneId)
}
